"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CetusGateway = void 0;
exports.getAlphaPrice = getAlphaPrice;
exports.getUSDYPrice = getUSDYPrice;
exports.getBUCKPrice = getBUCKPrice;
exports.getPriceFromCetus = getPriceFromCetus;
const tslib_1 = require("tslib");
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const coins_js_1 = require("../../common/coins.js");
const cetus_mainnet_config_js_1 = require("../../common/cetus_mainnet_config.js");
const prices_js_1 = require("../prices.js");
const simpleCache_js_1 = require("../simpleCache.js");
const poolData = {
    "SUI/USDC": {
        pair: "SUI/USDC",
        id: "0xcf994611fd4c48e277ce3ffd4d4364c914af2c3cbb05f7bf6facd371de688630",
        a2b: false,
    },
    "USDC/SUI": {
        pair: "USDC/SUI",
        id: "0xcf994611fd4c48e277ce3ffd4d4364c914af2c3cbb05f7bf6facd371de688630",
        a2b: true,
    },
    "SUI/USDT": {
        pair: "SUI/USDT",
        id: "0x06d8af9e6afd27262db436f0d37b304a041f710c3ea1fa4c3a9bab36b3569ad3",
        a2b: false,
    },
    "USDT/SUI": {
        pair: "USDT/SUI",
        id: "0x06d8af9e6afd27262db436f0d37b304a041f710c3ea1fa4c3a9bab36b3569ad3",
        a2b: true,
    },
    "USDC/USDT": {
        pair: "USDC/USDT",
        id: "0xc8d7a1503dc2f9f5b05449a87d8733593e2f0f3e7bffd90541252782e4d2ca20",
        a2b: false,
    },
    "USDT/USDC": {
        pair: "USDT/USDC",
        id: "0xc8d7a1503dc2f9f5b05449a87d8733593e2f0f3e7bffd90541252782e4d2ca20",
        a2b: true,
    },
    "SUI/VSUI": {
        pair: "SUI/VSUI",
        id: "0x6c545e78638c8c1db7a48b282bb8ca79da107993fcb185f75cedc1f5adb2f535",
        a2b: false,
    },
    "VSUI/SUI": {
        pair: "VSUI/SUI",
        id: "0x6c545e78638c8c1db7a48b282bb8ca79da107993fcb185f75cedc1f5adb2f535",
        a2b: true,
    },
    "SUI/NAVX": {
        pair: "SUI/NAVX",
        id: "0x0254747f5ca059a1972cd7f6016485d51392a3fde608107b93bbaebea550f703",
        a2b: false,
    },
    "NAVX/SUI": {
        pair: "NAVX/SUI",
        id: "0x0254747f5ca059a1972cd7f6016485d51392a3fde608107b93bbaebea550f703",
        a2b: true,
    },
    "ALPHA/SUI": {
        pair: "ALPHA/SUI",
        id: "0xda7347c3192a27ddac32e659c9d9cbed6f8c9d1344e605c71c8886d7b787d720",
        a2b: true,
    },
    "SUI/ALPHA": {
        pair: "ALPHA/SUI",
        id: "0xda7347c3192a27ddac32e659c9d9cbed6f8c9d1344e605c71c8886d7b787d720",
        a2b: false,
    },
    "USDY/USDC": {
        pair: "USDY/USDC",
        id: "0x0e809689d04d87f4bd4e660cd1b84bf5448c5a7997e3d22fc480e7e5e0b3f58d",
        a2b: true,
    },
    "USDC/USDY": {
        pair: "USDY/USDC",
        id: "0x0e809689d04d87f4bd4e660cd1b84bf5448c5a7997e3d22fc480e7e5e0b3f58d",
        a2b: false,
    },
    "BUCK/USDC": {
        pair: "BUCK/USDC",
        id: "0x81fe26939ed676dd766358a60445341a06cea407ca6f3671ef30f162c84126d5",
        a2b: true,
    },
    "USDC/BUCK": {
        pair: "USDC/BUCK",
        id: "0x81fe26939ed676dd766358a60445341a06cea407ca6f3671ef30f162c84126d5",
        a2b: false,
    },
};
const alphaPricePromiseCache = new simpleCache_js_1.SimpleCache(60000);
const alphaPriceCache = new simpleCache_js_1.SimpleCache(60000);
async function getAlphaPrice(ignoreCache = false) {
    const cacheKey = `getAlphaPrice`;
    if (ignoreCache) {
        alphaPriceCache.delete(cacheKey);
        alphaPricePromiseCache.delete(cacheKey);
    }
    const cachedResponse = alphaPriceCache.get(cacheKey);
    if (cachedResponse) {
        return cachedResponse;
    }
    let alphaPrice = 0;
    let cachedPromise = alphaPricePromiseCache.get(cacheKey);
    if (!cachedPromise) {
        cachedPromise = (async () => {
            const cetusGateway = new CetusGateway(cetus_mainnet_config_js_1.cetusMainnetSDKOptions);
            const swapOption = {
                pair: { coinA: coins_js_1.coinsList.ALPHA, coinB: coins_js_1.coinsList.SUI },
                senderAddress: "0x4260738f0f7341adc79a8edaa62f8a4681ebd27c595aecab1f322f47bfc52c5e",
                slippage: 1,
                inAmount: new bn_js_1.default(1000000000),
            };
            const res = await cetusGateway.getPrice(swapOption);
            const [latestSuiPrice] = await (0, prices_js_1.getLatestPrices)(["SUI/USD"], false);
            if (latestSuiPrice) {
                alphaPrice =
                    res.estimatedAmountOut.toNumber() * Number(latestSuiPrice) * 1e-9;
                alphaPriceCache.set(cacheKey, alphaPrice);
                alphaPricePromiseCache.delete(cacheKey); // Remove the promise from cache
            }
            return alphaPrice;
        })().catch((error) => {
            alphaPricePromiseCache.delete(cacheKey); // Remove the promise from cache
            throw error;
        });
        alphaPricePromiseCache.set(cacheKey, cachedPromise);
    }
    return cachedPromise;
}
async function getUSDYPrice() {
    const cetusGateway = new CetusGateway(cetus_mainnet_config_js_1.cetusMainnetSDKOptions);
    const swapOption = {
        pair: { coinA: coins_js_1.coinsList.USDY, coinB: coins_js_1.coinsList.USDC },
        senderAddress: "0x4260738f0f7341adc79a8edaa62f8a4681ebd27c595aecab1f322f47bfc52c5e",
        slippage: 1,
        inAmount: new bn_js_1.default(1000000),
    };
    const res = await cetusGateway.getPrice(swapOption);
    const [latestUSDCPrice] = await (0, prices_js_1.getLatestPrices)(["USDC/USD"], false);
    if (latestUSDCPrice) {
        return res.estimatedAmountOut.toNumber() * Number(latestUSDCPrice) * 1e-6;
    }
    else {
        return undefined;
    }
}
async function getBUCKPrice() {
    const cetusGateway = new CetusGateway(cetus_mainnet_config_js_1.cetusMainnetSDKOptions);
    const swapOption = {
        pair: { coinA: coins_js_1.coinsList.BUCK, coinB: coins_js_1.coinsList.USDC },
        senderAddress: "0x4260738f0f7341adc79a8edaa62f8a4681ebd27c595aecab1f322f47bfc52c5e",
        slippage: 1,
        inAmount: new bn_js_1.default(1000000000),
    };
    const res = await cetusGateway.getPrice(swapOption);
    const [latestUSDCPrice] = await (0, prices_js_1.getLatestPrices)(["USDC/USD"], false);
    if (latestUSDCPrice) {
        return res.estimatedAmountOut.toNumber() * Number(latestUSDCPrice) * 1e-6;
    }
    else {
        return undefined;
    }
}
async function getPriceFromCetus(coinType) {
    return coinType;
}
class CetusGateway {
    constructor(sdkOptions) {
        this.cetusSDK = new cetus_sui_clmm_sdk_1.CetusClmmSDK(sdkOptions);
        this.cetusSDK.senderAddress = sdkOptions.simulationAccount.address;
    }
    async getPools(pairs) {
        const allPools = await this.cetusSDK.Pool.getPoolsWithPage([]);
        const matchedPools = [];
        pairs.forEach((pair) => {
            const filteredPools = allPools.filter((pool) => {
                if (pair.coinA && pair.coinB) {
                    return ((pool.coinTypeA === pair.coinA.type &&
                        pool.coinTypeB === pair.coinB.type) ||
                        (pool.coinTypeA === pair.coinB.type &&
                            pool.coinTypeB === pair.coinA.type));
                }
                else if (pair.coinA && !pair.coinB) {
                    return (pool.coinTypeA === pair.coinA.type ||
                        pool.coinTypeB === pair.coinA.type);
                }
                else if (!pair.coinA && pair.coinB) {
                    return (pool.coinTypeB === pair.coinB.type ||
                        pool.coinTypeB === pair.coinB.type);
                }
                else {
                    return undefined;
                }
            });
            matchedPools.push(...filteredPools);
        });
        console.log(matchedPools);
        console.log(`Matched pools for specified pairs: ${matchedPools.length}`);
        console.log(`Total pools: ${allPools.length}`);
        return matchedPools;
    }
    async getPrice(options) {
        const { pair, inAmount, outAmount } = options;
        const poolDatum = poolData[pair.coinA.name + "/" + pair.coinB.name];
        let amount = new bn_js_1.default(0);
        let byAmountIn = true;
        if (inAmount) {
            byAmountIn = true;
            amount = inAmount;
        }
        else if (outAmount) {
            byAmountIn = false;
            amount = outAmount;
        }
        const pool = await this.cetusSDK.Pool.getPool(poolDatum.id);
        const swapTicks = await this.cetusSDK.Pool.fetchTicks({
            pool_id: pool.poolAddress,
            coinTypeA: pool.coinTypeA,
            coinTypeB: pool.coinTypeB,
        });
        const res = this.cetusSDK.Swap.calculateRates({
            decimalsA: pair.coinA.expo,
            decimalsB: pair.coinB.expo,
            a2b: poolDatum.a2b,
            byAmountIn,
            amount,
            swapTicks,
            currentPool: pool,
        });
        return res;
    }
    async getTransaction(options) {
        const res = await this.getPrice(options);
        const { pair, senderAddress, slippage, inAmount, outAmount } = options;
        const poolDatum = poolData[pair.coinA.name + "/" + pair.coinB.name];
        const poolID = poolDatum.id;
        const pool = await this.cetusSDK.Pool.getPool(poolID);
        let byAmountIn = true;
        if (inAmount) {
            byAmountIn = true;
        }
        else if (outAmount) {
            byAmountIn = false;
        }
        const slippagePercentage = new cetus_sui_clmm_sdk_1.Percentage(new bn_js_1.default(Math.floor(slippage * 100).toString()), new bn_js_1.default(100));
        const toAmount = byAmountIn
            ? res.estimatedAmountOut
            : res.estimatedAmountIn;
        const amountLimit = (0, cetus_sui_clmm_sdk_1.adjustForSlippage)(toAmount, slippagePercentage, !byAmountIn);
        // TransactionBlock
        this.cetusSDK.senderAddress = senderAddress;
        const txb = this.cetusSDK.Swap.createSwapTransactionPayload({
            pool_id: pool.poolAddress,
            coinTypeA: pool.coinTypeA,
            coinTypeB: pool.coinTypeB,
            a2b: poolDatum.a2b,
            by_amount_in: byAmountIn,
            amount: res.amount.toString(),
            amount_limit: amountLimit.toString(),
        });
        return txb;
    }
    async createPoolTransactionBlock(options) {
        console.log((0, cetus_sui_clmm_sdk_1.d)(options.initializePrice), coins_js_1.coinsList[options.coinNameA].expo, coins_js_1.coinsList[options.coinNameB].expo);
        const initializeSqrtPrice = cetus_sui_clmm_sdk_1.TickMath.priceToSqrtPriceX64((0, cetus_sui_clmm_sdk_1.d)(options.initializePrice), coins_js_1.coinsList[options.coinNameA].expo, coins_js_1.coinsList[options.coinNameB].expo).toString();
        const current_tick_index = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToTickIndex(new bn_js_1.default(Math.floor(parseFloat(initializeSqrtPrice)).toString()));
        // build tick range
        const lowerTick = cetus_sui_clmm_sdk_1.TickMath.getPrevInitializableTickIndex(new bn_js_1.default(Math.floor(current_tick_index).toString()).toNumber(), new bn_js_1.default(options.tickSpacing.toString()).toNumber());
        const upperTick = cetus_sui_clmm_sdk_1.TickMath.getNextInitializableTickIndex(new bn_js_1.default(Math.floor(current_tick_index).toString()).toNumber(), new bn_js_1.default(options.tickSpacing.toString()).toNumber());
        // slippage value 0.05 means 5%
        const slippage = 0.01;
        // Estimate liquidity and token amount from one amounts
        const liquidityInput = cetus_sui_clmm_sdk_1.ClmmPoolUtil.estLiquidityAndcoinAmountFromOneAmounts(lowerTick, upperTick, new bn_js_1.default(options.amount.toString()), options.isAmountA, true, slippage, new bn_js_1.default(initializeSqrtPrice.toString()));
        // Estimate  token a and token b amount
        const amount_a = options.isAmountA
            ? options.amount
            : liquidityInput.tokenMaxA.toNumber();
        const amount_b = options.isAmountA
            ? liquidityInput.tokenMaxB.toNumber()
            : options.amount;
        console.log({
            coinTypeA: coins_js_1.coinsList[options.coinNameA].type,
            coinTypeB: coins_js_1.coinsList[options.coinNameB].type,
            tick_spacing: options.tickSpacing,
            initialize_sqrt_price: `${initializeSqrtPrice}`,
            uri: options.imageUrl,
            amount_a: amount_a,
            amount_b: amount_b,
            fix_amount_a: options.isAmountA,
            tick_lower: lowerTick,
            tick_upper: upperTick,
        });
        // build creatPoolPayload Payload
        const txb = this.cetusSDK.Pool.creatPoolTransactionPayload({
            coinTypeA: coins_js_1.coinsList[options.coinNameA].type,
            coinTypeB: coins_js_1.coinsList[options.coinNameB].type,
            tick_spacing: options.tickSpacing,
            initialize_sqrt_price: `${initializeSqrtPrice}`,
            uri: options.imageUrl,
            amount_a: amount_a,
            amount_b: amount_b,
            fix_amount_a: options.isAmountA,
            tick_lower: lowerTick,
            tick_upper: upperTick,
            // New fields required by latest SDK
            metadata_a: "",
            metadata_b: "",
            slippage: slippage,
        });
        return txb;
    }
}
exports.CetusGateway = CetusGateway;
//# sourceMappingURL=prices.js.map